import MainGridController from '../../controllers/grid/MainGridController';
import { COMPONENTS } from '../../lib/constants';
import { StatusBarBgGrid } from './StatusBarBgGrid';

export const StatusBarBg = {
	name: COMPONENTS.STATUS_BAR_BG,
	position: {
		x: 0,
		y: 0
	},
	controllers: [
		{
			Controller: MainGridController,
			name: 'GridController',
			config: {
				grid: StatusBarBgGrid,
				vc: 'status_bar_mobile_container'
			}
		}
	],
	components: [
		{
			name: 'status_bar_mobile_container',
			type: 'Sprite',
			position: { x: 0, y: 0 },
			components: [
				{
					name: 'status_bar_mobile',
					type: 'Sprite',
					img: 'status_bar_mobile'
				}
				//TODO move win info here
			]
		}
	]
};
